import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin } from 'lucide-react';
import bluekraftLogo from '../../assets/bluekraftlogo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <img
                src={bluekraftLogo}
                alt="BluekraftMed Logo"
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-gray-400 mb-4">
              Leading Provider of Healthcare staffing services
            </p>
            <div className="flex space-x-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-600 transition-colors">
                <Linkedin className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-cyan-600 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-cyan-600 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-cyan-600 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-cyan-600 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services#staffing" className="text-gray-400 hover:text-cyan-600 transition-colors">
                  Staffing Solutions
                </Link>
              </li>
              <li>
                <Link to="/services#physicians" className="text-gray-400 hover:text-cyan-600 transition-colors">
                  Physicians & Advanced Practice
                </Link>
              </li>
              <li>
                <Link to="/services#locum" className="text-gray-400 hover:text-cyan-600 transition-colors">
                  Locum Tenens
                </Link>
              </li>
              <li>
                <Link to="/services#telehealth" className="text-gray-400 hover:text-cyan-600 transition-colors">
                  Telehealth
                </Link>
              </li>
              <li>
                <Link to="/nursing" className="text-gray-400 hover:text-cyan-600 transition-colors">
                  Nursing
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="w-5 h-5 text-cyan-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-gray-400">Phone:</p>
                  <a href="tel:+14694662313" className="text-white hover:text-cyan-600">
                    +1 (469)-466-2313
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-5 h-5 text-cyan-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-gray-400">Email:</p>
                  <a href='mailto:info@bluekraftmed.com' target="_blank">info@bluekraftmed.com</a>
                </div>
              </li>
            </ul>
          </div>
        </div >

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} BluekraftMed. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/" className="text-gray-400 hover:text-cyan-600 text-sm">
                Home
              </Link>
              <a href="tel:+14694662313" className="text-gray-400 hover:text-cyan-600 text-sm">
                Call Us
              </a>
              <Link to="/jobs" className="text-gray-400 hover:text-cyan-600 text-sm">
                Jobs
              </Link>
              <Link to="/contact" className="text-gray-400 hover:text-cyan-600 text-sm">
                Contact
              </Link>
            </div>
          </div >
        </div >
      </div >
    </footer >
  );
};

export default Footer;